import { render, staticRenderFns } from "./EditClinicianStaff.vue?vue&type=template&id=1219c4e8&"
import script from "./EditClinicianStaff.vue?vue&type=script&lang=js&"
export * from "./EditClinicianStaff.vue?vue&type=script&lang=js&"
import style0 from "./EditClinicianStaff.vue?vue&type=style&index=0&lang=css&"
import style1 from "./EditClinicianStaff.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports